// Sugalarm — cycle 315: compact "alarm protections need setup" banner.
//
// Android MOBILE shell only (self-gating on the native AlarmReliability
// plugin — renders null on web, iOS, both kiosks, and old APKs). Mounted
// by the Now screen's mobile-portrait layout in NORMAL FLOW below the
// alarm-banner row, so it can never obscure or displace an alarm control
// or the glucose display — and the mount additionally yields whenever an
// alarm episode is live. Dismissible per SESSION (sessionStorage — it
// returns on the next app launch while anything is still unmet); tapping
// the body deep-links to the Settings → Alarm Reliability checklist.

import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { useAlarmReliability } from "../../hooks/useAlarmReliability";
import styles from "./AlarmReliabilityBanner.module.css";

const DISMISS_KEY = "sugalarm.alarmReliabilityBannerDismissed";

function sessionDismissed(): boolean {
  try {
    return sessionStorage.getItem(DISMISS_KEY) === "1";
  } catch {
    return false;
  }
}

export default function AlarmReliabilityBanner() {
  const reliability = useAlarmReliability();
  const nav = useNavigate();
  const [dismissed, setDismissed] = useState(sessionDismissed);

  if (!reliability.available || dismissed) return null;
  if (reliability.unmetCount == null || reliability.unmetCount === 0) {
    return null;
  }
  const n = reliability.unmetCount;

  return (
    <div className={styles.banner} role="status">
      <button
        type="button"
        className={styles.bodyBtn}
        onClick={() => nav("/settings?section=alarm_reliability")}
      >
        <span className={styles.dot} aria-hidden />
        <span className={styles.text}>
          {n} alarm protection{n === 1 ? "" : "s"} need{n === 1 ? "s" : ""}{" "}
          setup
        </span>
        <span className={styles.chevron} aria-hidden>
          ›
        </span>
      </button>
      <button
        type="button"
        className={styles.dismiss}
        aria-label="Dismiss for this session"
        onClick={() => {
          try {
            sessionStorage.setItem(DISMISS_KEY, "1");
          } catch {
            /* storage unavailable — the in-memory state still dismisses */
          }
          setDismissed(true);
        }}
      >
        ×
      </button>
    </div>
  );
}
